<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
     <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
    <v-card class="box">
      <v-toolbar dense class="toolbar" flat color="white">
        <v-toolbar-title>Payment History</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-toolbar flat dense color="white">
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
        </v-text-field>
      </v-toolbar>
      <center style="color: red;"><b>Note : If you click on 'Generate Receipt', a receipt will be generated if the
          amount was deducted from your bank account, but due to some issues, the receipt was not generated.</b>
      </center><br>
      <v-data-table :headers="headers" :items="payment_history" class="elevation-1 mytable" dense :search="search">
        <template v-slot:item.raise_issue="{ item }">
          <span v-if="item.raise_issue == '--'">{{ item.raise_issue }}</span>
          <span v-else>
            <!-- <v-checkbox class="mr-5" color="#0f2027" dense v-model="raise_issue" :value="item.id"></v-checkbox> -->
            <v-btn small v-if="!item.already_raised" rounded class="button" @click="savedispute(item.id)">
              Raise Dispute
            </v-btn>
            <span v-else class="text-color">{{ item.already_raised }}</span>
          </span>
        </template>
        <template v-slot:item.raise_issue_status="{ item }">
          <span v-if="item.raise_issue_status == '--'">{{
            item.raise_issue_status
            }}</span>
          <span v-else>
            <span v-if="item.already_raised">
              <span class="text-color" v-if="!item.raise_issue_status">
                Pending
              </span>
              <span v-else> <strong>Resolved</strong> </span>
            </span>
            <span v-else> -- </span>
          </span>
        </template>
        <template v-slot:item.save="{ item }">
          <v-btn :disabled="item.generate_receipt == false || !pgs.includes('PayTM')" small rounded
            @click="generateReceipt(item)" class="button" :loading="save_loader">
            Generate Receipt
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Parent Transaction History Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/IZ5QtP_PACg?si=HQ-OSz7y5nep6tNA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    videoDialog:false,
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",
    loader: true,
    loader1: false,
    search: "",
    s3url: "",
    payment_history: "",
    raise_issue: null,
    pgs: [],
    headers: [
      {
        text: "Sr. No.",
        align: "left",
        sortable: false,
        value: "srno",
      },
      {
        text: "Learner",
        align: "left",
        sortable: false,
        value: "learner",
      },
      {
        text: "Amount",
        align: "left",
        sortable: false,
        value: "amount",
      },
      {
        text: "Paid For",
        align: "left",
        sortable: false,
        value: "purpose",
      },
      {
        text: "Order Id",
        align: "left",
        sortable: true,
        value: "order_id",
      },
      {
        text: "Transaction Id",
        align: "left",
        sortable: true,
        value: "trxn_id",
      },
      { text: "Transaction Date", value: "transaction_date", sortable: false },
      {
        text: "Payment Status",
        value: "paymenttransactionstatus",
        sortable: false,
      },
      { text: "Payment Mode", value: "mode", sortable: false },
      {
        text: "Generate Receipt",
        value: "save",
        sortable: false,
      },
      { text: "Raise Dispute", value: "raise_issue", sortable: false },
      {
        text: "Raise Dispute Status",
        value: "raise_issue_status",
        sortable: false,
      },

    ],
  }),
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    savedispute(item) {
      const data = {
        id: item,
      };
      axios
        .post("/AccountingAndFees/parent_payment_history_raise_issue", data)
        .then((res) => {
          if (res.data.msg == "200") {
            if ((res.data.status = "SUCCESS")) {
              this.showSnackbar("#4caf50", "Raised Dispute...");
              this.onload();
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
    async generateReceipt(item) {
      const data = {
        receipt_data: item.id,
      };
      try {
        this.save_loader = true;
        const res = await axios.post("/PaymentGatewayPayTM/generateReceipt", data);
        console.log("result", res.data);
        if (res.data.flag == "YES") {
          this.showSnackbar("#4caf50", "Receipt Generated...");
        } else {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          sessionStorage.setItem("error-trace", res.data.error_trace);
        }
        this.save_loader = false;
      } catch (error) {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
      } finally {
        this.save_loader = false;

      }
    },
    onload() {
      axios
        .post("/AccountingAndFees/parent_payment_history")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((res.data.status = "SUCCESS")) {
              this.payment_history = res.data.payment_history;
              this.pgs = res.data.pgs
            } else {
              this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            }
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          //close loader
          this.loader = false;
          //alert("done")
        });
    },
  },
  mounted() {
    //alert("this.s3url::"+this.s3url)
    this.onload();
  },
};
</script>

<style scoped>
.text-color {
  font-weight: bold;
  color: red;
  font-size: small;
}
</style>
